import logo from "./logo.svg";
import "./App.css";
import { Routes, Route, useNavigate } from "react-router-dom";
// import Footer from "./Components/Footer";
import Navbar from "./Components/Navbar/index.tsx";
import { Footermain } from "./Components/Footer";
import { Home } from "./Components/Screens/Home";
import { AirportService } from "./Components/Screens/AirportService";
import { RentACar } from "./Components/Screens/RentACar";
import { Login } from "./Components/Screens/Login";
import { Signup } from "./Components/Screens/Signup";
import { MainTravel } from "./Components/TravelAndTour";

function App() {
  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/AirportService" element={<AirportService />} />
        <Route path="/RentACar" element={<RentACar />} />
        <Route path="/MainTravel" element={<MainTravel />} />
        <Route path="/Login" element={<Login />} />
        <Route path="/Signup" element={<Signup />} />
      </Routes>
      <Footermain />
    </>
  );
}

export default App;
